import { getIsTrainIncident } from '@rsos/base-utils';
import { ACTIVE_ASSAILANT } from '@rsos/constants/alertTypes';

/**
 * Util function to check if the alert is regular or if it belongs to AAA or Train Incident alerts.
 * @param {Object} alert - full alert object
 */

export function isRegularAlert(alert) {
  return (
    alert &&
    alert.emergency_type.name !== ACTIVE_ASSAILANT &&
    getIsTrainIncident(alert.emergency_type.name, true)
  );
}
